import { createTheme } from '@mui/material/styles';

const primary = '#257adbff !important';
const secondary = '#484848ff';

const Theme = createTheme({
  palette: {
    primary: {
      main: primary,
    },
    secondary: {
      main: secondary,
    },
    text: {
      secondary: secondary,
    },
  },
  components: {
    MuiPickersSectionList: {
      styleOverrides: {
        root: {},
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: primary,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: primary,
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: primary,
        },
      },
    },
  },
});

export default Theme;
